import React, { Component } from 'react'

export default class SubmitButton extends Component {
  render() {
    const { label } = this.props
    return (
      <div>
        <button 
          className="text-white font-bold py-2 px-4 rounded mt-5 mb-20 pentagramma-button" 
          onClick={ this.props.onClick}
        >
            { label }
        </button>
      </div>
    )
  }
}
